import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ReformulacionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ReformulacionPage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexReformulacion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Fecha', name: 'r.Fecha', title: 'Fecha' },
                { data: 'Reformulacion', name: 'r.Reformulacion', title: 'Glosa' },
                {
                    data: 'Aprobado', name: 'Aprobado', title: 'Aprobado', render: function (data, type, row) {
                        if (row.Aprobado == 0) { return '<i class="fa fa-times text-danger font-italic font-weight-bold "> Borrador</i></span>'; }
                        else { return '<i class="fa fa-check text-success font-italic font-weight-bold"> Aprobado </i></span>'; }
                    }
                },
                { data: 'action', orderable: false, title: 'Acciones' },
            ],
            ajaxDetalle: {
                "url": ss.indexReformulacionDetalle(),
                headers: ss.getToken(),
                data: function (d) {
                    d.id = 1;
                }
            },
            columnsDetalle: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Poa', name: 'rd.Poa', title: 'N Mod Poa' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false,
                    render: function (data, type, row) {
                        if (row.Aprobado == 0) { return data }
                        else { return '<a class="btn btn-danger btn-xs" disabled><i class="fa fa-trash"></i> Eliminar</a>' }
                    }
                },
            ],
            rutaApp: process.env.VUE_APP_MAIN_SERVICE,
            isLoading: false,
            presupuestoBase: [],
            frm: {
                Formulacion: null
            },
            formulaciones: [],
            searchFormulacion: '',
            searchPartida: '',
            partidas: [],
            mostrarPresupuesto: false,
            partidaOrigen: null,
            partidaDestino: null,
            montoMovimiento: 0,
            disponibleOrigen: 0,
            movimientos: [],
            destino: {
                FuenteFinanciera: null,
                CategoriaProgramatica: null,
                Partida: null
            },
            nuevoDestino: false,
            nuevaFuente: null,
            nuevaCategoria: null,
            nuevaPartida: null,
            fuentes: [],
            categorias: [],
        };
    },
    methods: {
        onChangeOrigen() {
            if (this.partidaOrigen) {
                this.disponibleOrigen = this.partidaOrigen.Disponible;
            } else {
                this.disponibleOrigen = 0;
            }
        },

        eliminarMovimiento(index) {

            // Devolver disponible visualmente
            this.disponibleOrigen += this.movimientos[index].monto;

            this.movimientos.splice(index, 1);
        },
        agregarMovimiento() {

            if (!this.partidaOrigen || !this.partidaDestino) {
                alert("Debe seleccionar origen y destino");
                return;
            }

            if (this.montoMovimiento <= 0) {
                alert("Monto inválido");
                return;
            }

            // 🔴 AQUÍ VA
            if (this.montoMovimiento > this.disponibleOrigen) {
                alert("El monto supera el disponible de la partida origen");
                return;
            }

            if (this.nuevoDestino) {

                if (!this.nuevaFuente || !this.nuevaCategoria || !this.nuevaPartida) {
                    alert("Debe completar Fuente, Categoría y Partida");
                    return;
                }

            }

            // Si pasa validación
            this.movimientos.push({
                origen: this.partidaOrigen,
                destino: this.partidaDestino,
                monto: this.montoMovimiento
            });

            // Actualizamos disponible visualmente
            this.disponibleOrigen -= this.montoMovimiento;

            // Limpiar campos
            this.montoMovimiento = 0;
            this.partidaDestino = null;
        },
        newReformulacion() {
            this.frm.Formulacion = null;
            this.presupuestoBase = [];
            this.formulaciones = [];
            this.searchFormulacion = '';

            this.$bvModal.show('frm-reformulacion');
        },
        getPresupuesto() {

            if (!this.frm.Formulacion) return;

            this.isLoading = true;

            this.ss.getPresupuestoBase(this.frm.Formulacion)
                .then(res => {
                    if (res.data.success) {
                        this.presupuestoBase = res.data.data;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        draw() {
            window.$('.btn-datatable-Reformulacion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showReformulacion(data);
            });
        },
        drawDetalle() {
            // this.idReformulacion=1;
            window.$('.btn-datatable-ReformulacionDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.deleteReformulacionDetalle(data);
            });

        },
        selectFormulacion(f) {
            this.frm.Formulacion = f.id;
            this.searchFormulacion = f.Concatenado + ' - ' + f.Formulacion;
            this.formulaciones = [];
            this.getPresupuesto();
        }

    },
    watch: {
        searchFormulacion(q) {

            if (!q || q.length < 2) {
                this.formulaciones = [];
                return;
            }

            this.ss.select2Formulacion(q)
                .then(res => {
                    if (res.data.success) {
                        this.formulaciones = res.data.items;
                    }
                });
        },
        searchPartida(q) {
            this.ss.select2Partida(q).then((res) => {
                if (res.data.success) {
                    this.partidas = res.data.items;
                } else {
                    this.partidas = [];
                }
            });
        },
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            //this.getPartida();
        }
    }
};
